<template>
    <div>
      <div class="survey-module-right-action">
          <div class="table-controls justify-between">
              <div class="table-controls-btn align-center">
                <!-- <div class="table-controls-btn-item btn-color1" @click="handleOpen()">新增（内蒙古心理咨询师行业水平考试）</div> -->
                <div class="table-controls-btn-item btn-color1" @click="handleOpen()">新增</div>
                <!-- <div class="table-controls-btn-item btn-color2" @click="dialogVisible = true">导入</div> -->
                <!-- <div class="table-controls-btn-item btn-color3" @click="exportFun()">导出</div> -->
              </div>
              <div class="table-controls-btn align-center">
                <input type="text" v-model="queryParams.name" placeholder="请输入考生姓名" autocomplete="off">
                <div class="table-controls-btn-item btn-color3" @click="handleQuery()">搜索</div>
                <div class="table-controls-btn-item btn-color4" @click="resetQuery()">重置</div>
              </div>
            </div>
            <div class="table-body">
              <el-table
                v-loading="loading"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%;"
                :header-cell-style="{background:'#72b701',color:'#fff'}"
              >
                <el-table-column prop="name" label="姓名" align="center" :show-overflow-tooltip="true"/>
                <!-- <el-table-column prop="identityCard" label="身份证号" min-width="150" align="center" :show-overflow-tooltip="true"/> -->
                <el-table-column prop="sex" label="性别" align="center" :show-overflow-tooltip="true"/>
                <el-table-column prop="birthday" label="出生日期" min-width="150" align="center" :show-overflow-tooltip="true"/>
                <el-table-column prop="nation" label="民族" align="center" :show-overflow-tooltip="true"/>
                <el-table-column prop="qualification" label="学历" align="center" :show-overflow-tooltip="true"/>
                <el-table-column prop="politicalOutlook" label="政治面貌" min-width="150" align="center" :show-overflow-tooltip="true"/>
                <el-table-column prop="phone" label="手机号" align="center" :show-overflow-tooltip="true"/>
                <el-table-column prop="address" label="地址" min-width="200" align="center" :show-overflow-tooltip="true">
                  <template #default="scope">
                    {{ dizhiAction(scope.row.address) }}
                  </template>
                </el-table-column>
                <el-table-column prop="fullAddress" label="详细地址" min-width="150" align="center" :show-overflow-tooltip="true"/>
                <!-- <el-table-column prop="registeredResidence" label="户籍所在地" min-width="200" align="center" :show-overflow-tooltip="true">
                  <template #default="scope">
                    {{ dizhiAction(scope.row.registeredResidence) }}
                  </template>
                </el-table-column> -->
                <el-table-column prop="subject" label="科目" align="center" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span v-if="scope.row.subject==0">理论加实操</span>
                    <span v-if="scope.row.subject==1">理论</span>
                    <span v-if="scope.row.subject==2">实操</span>
                  </template>
                </el-table-column>
                <el-table-column prop="level" label="级别" align="center" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    {{ scope.row.level }}级
                  </template>
                </el-table-column>
                <el-table-column prop="qualified" label="具备条件" min-width="150" align="center" :show-overflow-tooltip="true"/>
                <el-table-column prop="life" label="从业年限" min-width="150" align="center" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    {{ scope.row.life=='more'?'10年以上':scope.row.life+'年' }}
                  </template>
                </el-table-column>
                <el-table-column prop="examFrequency" label="考次" align="center" :show-overflow-tooltip="true"/>
                <el-table-column min-width="150" prop="source" label="基地" align="center" :show-overflow-tooltip="true"/>
                <el-table-column prop="auditStatus" label="审核状态" min-width="150" align="center" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span v-if="scope.row.auditStatus!='未通过'">{{ scope.row.auditStatus }}</span>
                    <el-button v-else @click="handleOpen(scope.row)" type="text" size="small">未通过(重新提交)</el-button>
                  </template>
                </el-table-column>
                <el-table-column min-width="150" prop="reason" label="未通过原因" align="center" :show-overflow-tooltip="true"/>
                <!-- <el-table-column
                  fixed="right"
                  label="操作"
                  align="center" width="100" >
                  <template slot-scope="scope">
                    <el-button @click="handleOpen(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button type="text" size="small" @click="deleteItemFun(scope.row.id)">删除</el-button>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
            <div class="pagination-content justify-end">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.pageNum"
                  :page-size="queryParams.pageSize"
                  background
                  layout="total,prev, pager, next, jumper"
                  prev-text="上一页"
                  next-text="下一页"
                  :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
          :title="dialog.title"
          :visible.sync="dialog.visible"
          width="40%"
          >
          <div class="login-form-box">
            <el-form :model="referForm" :rules="referRules" ref="referForm" label-position='right'>
              <el-form-item prop="url" label="照片">
                <el-upload
                  class="avatar-uploader"
                  :headers="headers"
                  :action="$baseUrl +'/api/file/upload'"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :on-error="handleAvatarError"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="referForm.url" :src="$baseUrl +referForm.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item prop="name" label="姓名">
                <el-input v-model="referForm.name" placeholder="姓名"/>
              </el-form-item>
              <el-form-item prop="identityCard" label="身份证号">
                <el-input v-model="referForm.identityCard" placeholder="身份证号"/>
              </el-form-item>
              <el-form-item prop="sex" label="性别">
                <el-radio-group v-model="referForm.sex">
                  <el-radio label="男">男</el-radio>
                  <el-radio label="女">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="birthday" label="出生日期">
                <el-date-picker
                 style="width: 100%;"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  v-model="referForm.birthday"
                  type="date"
                  placeholder="出生日期"
                   :editable="false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item prop="nation" label="民族">
                <el-input v-model="referForm.nation" placeholder="民族"/>
              </el-form-item>
              <el-form-item prop="qualification" label="学历">
                <el-select v-model="referForm.qualification" placeholder="请选择" style="width: 100%;">
                  <el-option label="博士" value="博士"/>
                  <el-option label="研究生" value="研究生"/>
                  <el-option label="本科" value="本科"/>
                  <el-option label="大学专科" value="大学专科"/>
                  <el-option label="中专" value="中专"/>
                  <el-option label="其他" value="其他"/>
                </el-select>
              </el-form-item>
              <el-form-item prop="politicalOutlook" label="政治面貌">
                <el-select v-model="referForm.politicalOutlook" placeholder="请选择" style="width: 100%;">
                  <el-option label="党员" value="党员"/>
                  <el-option label="团员" value="团员"/>
                  <el-option label="群众" value="群众"/>
                </el-select>
              </el-form-item>
              <el-form-item prop="phone" label="手机号">
                <el-input v-model="referForm.phone" placeholder="手机号"/>
              </el-form-item>
              <el-form-item prop="address" label="地址">
                <!-- <el-input v-model="referForm.address" placeholder="地址"/> -->
                <el-cascader
                  style="width: 100%;"
                  
                  :options="addressArr"
                  v-model="referForm.address">
                </el-cascader>
              </el-form-item>
              <el-form-item prop="fullAddress" label="详细地址">
                <el-input v-model="referForm.fullAddress" placeholder="详细地址" type="textarea"/>
              </el-form-item>
              <!-- <el-form-item prop="registeredResidence" label="户籍所在地">
                <el-cascader
                  style="width: 100%;"
                  :options="addressArr"
                  v-model="referForm.registeredResidence">
                </el-cascader>
              </el-form-item> -->
              <el-form-item prop="subject" label="科目">
                <el-select v-model="referForm.subject" placeholder="请选择" style="width: 100%;">
                  <el-option label="理论与实践" :value="'0'"/>
                  <el-option label="理论" :value="'1'"/>
                  <el-option label="实践" :value="'2'"/>
                </el-select>
              </el-form-item>
              <el-form-item prop="level" label="级别">
                <el-select v-model="referForm.level" placeholder="请选择" style="width: 100%;">
                  <el-option label="心理咨询师二级" :value="'2'"/>
                  <el-option label="心理咨询师三级" :value="'3'"/>
                </el-select>
              </el-form-item>
              <el-form-item prop="qualified" label="具备条件">
                <!-- <el-input v-model="referForm.qualified" placeholder="具备条件"/> -->
                <el-select
                  v-model="referForm.qualified"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option label="1.具有博士学历" value="具有博士学历" />
                  <el-option
                    label="2.具有硕士学历，经正规培训达规定标准学时数，并取得结业证书"
                    value="具有硕士学历，经正规培训达规定标准学时数，并取得结业证书"
                  />
                  <el-option
                    label="3.取得初级心理咨询师(三级)证书后，连续从事心理咨询工作满2年，经正规培训达规定标准学时数，并取得结业证书"
                    value="取得初级心理咨询师(三级)证书后，连续从事心理咨询工作满2年，经正规培训达规定标准学时数，并取得结业证书"
                  />
                  <el-option
                    label="4.具有相关专业中级及以上专业技术职业任职资格*，经正规培训达规定标准学时数，并取得结业证书，连续从事心理咨询工作满2年"
                    value="具有相关专业中级及以上专业技术职业任职资格*，经正规培训达规定标准学时数，并取得结业证书，连续从事心理咨询工作满2年"
                  />
                </el-select>
              </el-form-item>
              <el-form-item prop="life" label="从业年限">
                <el-select v-model="referForm.life" placeholder="请选择" style="width: 100%;">
                  <el-option label="未从事过" value="0"/>
                  <el-option label="1年" :value="'1'"/>
                  <el-option label="2年" :value="'2'"/>
                  <el-option label="3年" :value="'3'"/>
                  <el-option label="4年" :value="'4'"/>
                  <el-option label="5年" :value="'5'"/>
                  <el-option label="6年" :value="'6'"/>
                  <el-option label="7年" :value="'7'"/>
                  <el-option label="8年" :value="'8'"/>
                  <el-option label="9年" :value="'9'"/>
                  <el-option label="10年" :value="'10'"/>
                  <el-option label="10年以上" :value="'more'"/>
                </el-select>
              </el-form-item>
              <el-form-item prop="examFrequency" label="考次">
                <el-select v-model="referForm.examFrequency" placeholder="请选择" style="width: 100%;">
                  <el-option label="初考" value="初考"/>
                  <el-option label="补考" value="补考"/>
                </el-select>
              </el-form-item>
              <el-form-item>
                <div class="login-form-btn justify-center align-center" @click="handleSubmit('referForm')">提交{{ dialog.title }}</div>
              </el-form-item>
            </el-form>
           </div>
        </el-dialog>
        <!-- 导入弹窗 -->
        <el-dialog
          title="导入考生"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose">
          <div style="display: flex;justify-content: center;">
            <el-upload
            class="upload-demo"
            drag
            :headers="headers"
            :action="$baseUrl +'/api/file/upload'"
            :on-success="handleSuccess"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="daoruFun()">开始导入</el-button>
          </span>
        </el-dialog>
    </div>
  </template>
  
  <script>
  import {
  provinceAndCityData,
  pcTextArr,
  regionData,
  pcaTextArr,
  codeToText,
} from "element-china-area-data";
  import { getList, addItem, editItem, delItem,uploadScore } from "@/api/ksgl_ks";
  export default {
    props:['examId'],
    data(){
      return{
        headers:{
          "token":localStorage.getItem("foregroundToken")
        },
        loading:false,
        queryParams:{
          pageNum: 1,
          pageSize: 10,
          name: "",
        },
        total:0,
        tableData: [],
        dialog:{
          title:'',
          visible:false
        },
        referForm: {
          id: undefined,
          // 照片
          url:'',
          // 姓名
          name:'',
          // 身份证号
          identityCard:'',
          // 性别
          sex:'',
          // 出生日期
          birthday:'',
          // 民族
          nation:'',
          // 学历
          qualification:'',
          // 政治面貌
          politicalOutlook:'',
          // 手机号
          phone:'',
          // 地址
          address:'',
          // 详细地址
          fullAddress:'',
          // 户籍所在地
          // registeredResidence:'',
          // 科目：0理论加实操，1理论，2实操
          subject:'',
          // 心理咨询师级别  2二级 3三级 4四级
          level:'',
          // 具备条件(传值待定)
          qualified:'',
          // 从业年限  几年就是几,十年以上传more
          life:'',
          // 考次
          examFrequency:'',
        },
        referRules: {
          url: [{ required: true, message: "请上传照片", trigger: "blur" }],
          name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
          identityCard: [
            { required: true, message: "请输入身份证号", trigger: "blur" },
            {
              pattern:
                /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: "证件号码格式有误！",
              trigger: "blur",
            },
          ],
          sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
          birthday: [{ required: true, message: "请选择出生日期", trigger: "blur" }],
          nation: [{ required: true, message: "请输入民族", trigger: "blur" }],
          qualification: [{ required: true, message: "请输入学历", trigger: "blur" }],
          politicalOutlook: [{ required: true, message: "请输入政治面貌", trigger: "blur" }],
          phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
          address: [{ required: true, message: "请输入地址", trigger: "blur" }],
          fullAddress: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
          // registeredResidence: [{ required: true, message: "请输入户籍所在地", trigger: "blur" }],
          subject: [{ required: true, message: "请选择科目", trigger: "blur" }],
          level: [{ required: true, message: "请选择心理咨询师级别", trigger: "blur" }],
          qualified: [{ required: true, message: "请输入具备条件", trigger: "blur" }],
          life: [{ required: true, message: "请选择从业年限", trigger: "blur" }],
          examFrequency: [{ required: true, message: "请输入考次", trigger: "blur" }],
        },

        // 导入
        dialogVisible: false,
        fileList:[],
        addressArr:[]
      }
    },
    created(){
        this.handleQuery()
        this.addressArr = pcaTextArr
    },
    methods:{
      dizhiAction(arr) {
        let newarr = JSON.parse(arr);
        return newarr[0] + "/" + newarr[1] + "/" + newarr[2];
      },
      handleOpen(row){
        if(row){
          for(let key in this.referForm){
            // if (key == "address" || key == "registeredResidence") {
            //   this.referForm[key] = JSON.parse(row[key]);
            // } else {
            //   this.referForm[key] = row[key];
            // }
            if (key == "address") {
              this.referForm[key] = JSON.parse(row[key]);
            } else {
              this.referForm[key] = row[key];
            }
          }
        }
        this.dialog.title = row?'编辑考生':'新增考生'
        this.dialog.visible = true
      },
      handleCurrentChange(val) {
        this.queryParams.pageNum = val
        this.handleQuery()
      },
   
      /** 查询 */
      handleQuery() {
        this.loading = true;
        getList({
           examId:this.examId,
          ...this.queryParams
          })
          .then(({ data }) => {
            this.tableData = data.list;
            this.total = data.total;
          })
          .finally(() => {
            this.loading = false;
          });
      },
      /** 角色保存提交 */
      handleSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            const roleId = this.referForm.id;
            let obj = {
              address: JSON.stringify(this.referForm.address),
              // registeredResidence: JSON.stringify(this.referForm.registeredResidence),
            };
            if (roleId) {
              editItem(roleId, {
                examId:this.examId,
                ...this.referForm,
                ...obj,
                reason:'',
                auditStatus:'未审核'
              })
                .then((res) => {
                  this.$message({type: 'success', message: res.message});
                  this.closeDialog();
                  this.resetQuery();
                })
                .finally(() => {
                  this.loading = false
                });
            } else {
              addItem({
                examId:this.examId,
                ...this.referForm,
                ...obj,
                 reason:'',
                 auditStatus:'未审核'
              } )
                .then((res) => {
                  this.$message({type: 'success', message: res.message});
                  this.closeDialog();
                  this.resetQuery();
                })
                .finally(() => {
                  this.loading = false
                });
            }
          }
        });
      },
      /** 关闭表单弹窗 */
      closeDialog() {
        this.dialog.visible = false;
        this.resetForm();
      },
      /** 重置表单 */
      resetForm() {
        this.referForm.id = undefined;
        for(let key in this.referForm){
          this.referForm[key] = ''
        }
        this.queryParams.pageNum = 1
        this.handleQuery()
      },
      /** 重置查询 */
      resetQuery() {
        this.queryParams.pageNum = 1;
        this.queryParams.name = ''
        this.handleQuery();
      },
      deleteItemFun(id){ 
        this.$confirm('此操作将永久删除此会员, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            delItem([id]).then((res)=>{
              this.handleQuery()
              this.$message({
                type: 'success',
                message: res.message
              });
            })
           
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
      },
      // 上传-start
      handleAvatarSuccess(res, file) {
        this.referForm.url = res.data.filePath
      },
      handleAvatarError() {
        this.$confirm('当前页面已失效，请重新登录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const identity = localStorage.getItem("identity")
        this.$router.push({ path:'/loginPage',query:{tab:identity=='admin'?2:0}});
        localStorage.setItem("foregroundToken","")
        localStorage.setItem("identity","")
      })
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M;
      },
      // 上传-end

      // 导入
    
      handleSuccess(response, file,fileList){
        let arr = []
        for(let i=0;i<fileList.length;i++){
          arr.push(fileList[i].response.data.filePath)
        }
        this.fileList = arr
      },
      daoruFun(){
        uploadScore(this.fileList).then((res)=>{
          this.$message.success(res.message);
          this.handleClose()
        })
      },
      handleClose() {
        this.dialogVisible = false
        this.fileList = []
      },
      // 导出
      exportFun(){
        fetch(`${this.$baseUrl}/api/examinee/export`, {headers:this.headers })
          .then((response) => response.blob())
          .then((blob) => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "考生管理导出.xlsx";
            link.click();
          });
      }
    }
  }
  </script>
<style scoped lang="css" src="../../views/ksgl-page/assets/css/rem.css" />
<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>